import _classCallCheck from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Dropdown/dropdown';
import { css } from '@patternfly/react-styles';
import { DropdownMenu } from './DropdownMenu';
import { DropdownContext, DropdownDirection, DropdownPosition } from './dropdownConstants';
import { getOUIAProps } from '../../helpers';
export var DropdownWithContext =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DropdownWithContext, _React$Component);

  function DropdownWithContext(props) {
    var _this;

    _classCallCheck(this, DropdownWithContext);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DropdownWithContext).call(this, props));
    _this.openedOnEnter = false;
    _this.baseComponentRef = React.createRef();

    _this.onEnter = function () {
      _this.openedOnEnter = true;
    };

    if (props.dropdownItems && props.dropdownItems.length > 0 && props.children) {
      // eslint-disable-next-line no-console
      console.error('Children and dropdownItems props have been provided. Only the dropdownItems prop items will be rendered');
    }

    return _this;
  }

  _createClass(DropdownWithContext, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (!this.props.isOpen) {
        this.openedOnEnter = false;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _a = this.props,
          children = _a.children,
          className = _a.className,
          direction = _a.direction,
          dropdownItems = _a.dropdownItems,
          isOpen = _a.isOpen,
          isPlain = _a.isPlain,
          isGrouped = _a.isGrouped,
          onSelect = _a.onSelect,
          position = _a.position,
          toggle = _a.toggle,
          autoFocus = _a.autoFocus,
          ouiaId = _a.ouiaId,
          ouiaComponentType = _a.ouiaComponentType,
          props = __rest(_a, ["children", "className", "direction", "dropdownItems", "isOpen", "isPlain", "isGrouped", "onSelect", "position", "toggle", "autoFocus", "ouiaId", "ouiaComponentType"]);

      var id = toggle.props.id || "pf-toggle-id-".concat(DropdownWithContext.currentId++);
      var component;
      var renderedContent;
      var ariaHasPopup = false;

      if (dropdownItems && dropdownItems.length > 0) {
        component = 'ul';
        renderedContent = dropdownItems;
        ariaHasPopup = true;
      } else {
        component = 'div';
        renderedContent = React.Children.toArray(children);
      }

      var openedOnEnter = this.openedOnEnter;
      return React.createElement(DropdownContext.Consumer, null, function (_ref) {
        var baseClass = _ref.baseClass,
            baseComponent = _ref.baseComponent,
            contextId = _ref.id;
        var BaseComponent = baseComponent;
        return React.createElement(BaseComponent, Object.assign({}, props, {
          className: css(baseClass, direction === DropdownDirection.up && styles.modifiers.top, position === DropdownPosition.right && styles.modifiers.alignRight, isOpen && styles.modifiers.expanded, className),
          ref: _this2.baseComponentRef
        }, getOUIAProps(ouiaComponentType, ouiaId)), React.Children.map(toggle, function (oneToggle) {
          return React.cloneElement(oneToggle, {
            parentRef: _this2.baseComponentRef,
            isOpen: isOpen,
            id: id,
            isPlain: isPlain,
            'aria-haspopup': ariaHasPopup,
            onEnter: function onEnter() {
              return _this2.onEnter();
            }
          });
        }), isOpen && React.createElement(DropdownMenu, {
          component: component,
          isOpen: isOpen,
          position: position,
          "aria-labelledby": contextId ? "".concat(contextId, "-toggle") : id,
          openedOnEnter: openedOnEnter,
          isGrouped: isGrouped,
          autoFocus: openedOnEnter && autoFocus
        }, renderedContent));
      });
    }
  }]);

  return DropdownWithContext;
}(React.Component); // seed for the aria-labelledby ID

DropdownWithContext.currentId = 0;
DropdownWithContext.defaultProps = {
  className: '',
  dropdownItems: [],
  isOpen: false,
  isPlain: false,
  isGrouped: false,
  position: DropdownPosition.left,
  direction: DropdownDirection.down,
  onSelect: function onSelect() {
    return undefined;
  },
  autoFocus: true,
  ouiaComponentType: 'Dropdown'
};